const inputs = {
  paymentPeriod: {
    label: 'Payment Period (Days)',
    placeholder: 'Days',
    tooltipHint: 'The number of days the client has to pay the invoice'
  },
  useEndOfMonth: {
    label: 'Use End-of-Month Terms',
    description: `Count days from the first day of the next month.
      Example: 14 days EOM -> due on the 14th of the following month`
  }
}

export const text = {
  inputs
} as const
